<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import {decode, encode} from "../../../helpers";

    const user = store('credential', 'getAuth');

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))

            width.set(+fetched.ind4);
            height.set(+fetched.ind5);
            ind2.set(json.ind2);
            ind1 = json.ind1;
            ind6 = json.ind6;
            ind3 = json.ind3;
            tip = json.tip;
            tkan = json.tkan;

            count.set(+item.quantity)
            comment.set(item.comment)

            changeInd2();
            change()


        }
    };

    // костыль для 25 склада
    if (APP_TYPE === 'plisse-ltd' && parseInt($user.idSklad) === 25) {
        options = {
            ...options,
            max: {
                width: 6000,
                height: 3000,
            }
        }
    }

    const otkrivanie = [
        'Створка влево',
        'Створка вправо',
        'Створка сверху вниз',
        'Створка снизу вверх',
        'Створка от краев к середине',
        'Створка от середины к краям',
        'Створки от краев к середине горизонтальные',
    ];

    const porojek = options.porojek || {
        'без порожка': 'Рамный',
        'с порожком': 'Односторонний(10мм)'
    };

    const color = options.color || {
        'Антрацит(7016RAL)': 'Антрацит(7016RAL)',
        'Белый(9016RAL)': 'Белый(9016RAL)',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
        'Неокрашенный': 'Неокрашенный',
        'Цветной': 'Цветной',
    }

    const setka = [
        'Стандарт',
        'Антикошка',
        'Антимошка',
    ];
   /* 'ТКАНЬ',
        'ТКАНЬ'*/
    const tip_Polotno =
        [
            'СЕТКА',

            'СЕТКА-ТКАНЬ'
        ];


    const tip_Polotno2 =
        [
            'СЕТКА',

        ];


    const tkani =
        [
            'Блэкаут, влагостойкая',
            'Блэкаут сотовая, влагостойкая',
            'Полупрозрачная, влагостойкая',
        ];

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Плиссе 16мм-new', '', color);
        let options = await network.fetch_ind('Плиссе 16мм-new');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '2100'),
        ind1 = 'без порожка', // порожек
        ind2 = parameter('color', Object.values(color).shift()), // цветБелый(9016RAL)
        ind3 = 'Створка влево', // открывание
        ind6 = 'Стандарт', // тип сетки
        tip = 'СЕТКА', // тип полотна
        tkan = 'Блэкаут, влагостойкая',
        uplot ='Без уплотнения',
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);

    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };

    const  changeTkan = () => {


        if (tip.includes('ТКАНЬ') ) {

            if (tkan.includes('сотовая')) {
                options = {
                    ...options,
                    max: {
                        width: 1000,
                        height: 2000,
                    }
                }
            }
            else {
                options = {
                    ...options,
                    max: {
                        width: 3000,
                        height: 2400,
                    }
                }

            }

        }
        else {
            options = {
                ...options,
                max: {
                    width: 6000,
                    height: 3000,
                }
            }

        }

        // Проверяем и корректируем значения ширины и высоты
        if ($width > options.max.width) {
            $width = options.max.width;
        }
        if ($height > options.max.height) {
            $height = options.max.height;
        }


    };


    const changeInd3 = () => {
        if (ind3.includes('Створка сверху вниз') || ind3.includes('Створка снизу вверх')) {
            ind1 = 'без порожка';

        }
        if (!ind3.includes('от краев') && tip=='СЕТКА-ТКАНЬ') {
            tip='СЕТКА'
        }

    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height
        ;

        let ind1Str;

        switch (ind1) {
            case 'без порожка':
                ind1Str = 'порог рамный';
                break;

            case 'с порожком':
                ind1Str = 'порог односторонний(10мм)';
                break;
        }

        const calc_name = calc?.alt?.[$user.idSklad] ?? calc.title

        let result = {
            type: 'плиссе-16 New',
            name: calc_name,
            subname: [
                $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', tip, ' ', (tip.includes('СЕТКА') ? ' сетка ' +ind6: ''),  ' ', (tip.includes('ТКАНЬ') ? ' ткань ' +tkan: ''),  ' ',
                ind1Str
            ].join(''),
            title: [
                calc_name, ' ', $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', tip, ' ', (tip.includes('СЕТКА') ? ' сетка ' +ind6: ''),  ' ', (tip.includes('ТКАНЬ') ? ' ткань ' +tkan: ''),  ' ',
                ind1Str
            ].join(''),
            params: {
                ind1: ind1Str,
                ind2: $ind2,
                ind3: encode(JSON.stringify({
                    ind1,
                    ind2: $ind2,
                    ind3,
                    tip,
                    ind6,
                    tkan,
                })),
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            maxDay: 0,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 30
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль рамный п16 new')) {
                switch (ind1) {
                    case 'с порожком': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                            case 'Створки от краев к середине горизонтальные':
                                kolvo = (((w - 30) + (h - 47) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'без порожка': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                            case 'Створки от краев к середине горизонтальные':
                                kolvo = (((w - 30) * 2 + (h - 54) * 2) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = (((h - 30) * 2 + (w - 54) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('профиль створочный п16 new')) {
                switch (ind1) {
                    case 'с порожком': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 49) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((h - 49) / 1000 * 2).toFixed(3);
                                break;

                            case 'Створки от краев к середине горизонтальные':
                                kolvo = ((w - 61) / 1000 * 2).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'без порожка': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((h - 61) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w - 61) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((h - 61) / 1000 * 2).toFixed(3);
                                break;

                            case 'Створки от краев к середине горизонтальные':
                                kolvo = ((w - 61) / 1000 * 2).toFixed(3);
                                break;
                        }
                        break;
                    }
                }
            }

            if (name.includes('порог мс плиссе 16мм')) {
                if (ind1 === 'Есть' || ind1 === 'с порожком' || ind1 === 'односторонний(10мм)') {
                    kolvo = ((w - 24) / 1000).toFixed(3);
                }
            }

            if (((name.includes('сетка мс плиссе 20 мм') && name.includes(ind6.toLowerCase())) || (ind6 == "Стандарт" && name == "Сетка МС Плиссе 20 мм.".toLowerCase())) && tip.includes('СЕТКА') ) {
                let wave;

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        wave = Math.ceil(h / 20);
                        kolvo = (0.04 * wave * (w - 30) / 1000 * 0.8).toFixed(3);
                        break;
                    case  'Створки от краев к середине горизонтальные':
                        wave = Math.ceil(h / 20 / (tip.includes('СЕТКА/ТКАНЬ') ? 2 : 1));
                        kolvo = (0.04 * wave * (w - 30) / 1000 * 0.8).toFixed(3);
                        break;
                    case  'Створка от краев к середине':
                        wave = Math.ceil(w / 20 / (tip.includes('СЕТКА/ТКАНЬ') ? 2 : 1));
                        kolvo = (0.04 * wave * (w - 30) / 1000 * 0.8).toFixed(3);
                        break;

                    default:
                        wave = Math.ceil(w / 20);
                        kolvo = (0.04 * wave * (h - (ind1 === 'с порожком' ? 20 : 30)) / 1000 * 0.8).toFixed(3);
                        break;


                }
            }

            if (name.includes('ткань') && name.includes(tkan.toLowerCase()) && tip.includes('ТКАНЬ') ) {
                let wave;

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        wave = Math.ceil(h / 20);
                        kolvo = (0.04 * wave * (w - 30) / 1000 * 0.8).toFixed(3);
                        break;
                    case  'Створки от краев к середине горизонтальные':
                        wave = Math.ceil(h / 20 / (tip.includes('СЕТКА/ТКАНЬ') ? 2 : 1));
                        kolvo = (0.04 * wave * (w - 30) / 1000 * 0.8).toFixed(3);
                        break;

                    case  'Створка от краев к середине':
                        wave = Math.ceil(w / 20 / (tip.includes('СЕТКА/ТКАНЬ') ? 2 : 1));
                        kolvo = (0.04 * wave * (w - 30) / 1000 * 0.8).toFixed(3);
                        break;
                    default:
                        wave = Math.ceil(w / 20);
                        kolvo = (0.04 * wave * (h - (ind1 === 'с порожком' ? 20 : 30)) / 1000 * 0.8).toFixed(3);
                        break;
                }
            }

            if (name.includes('нить мс плиссе')) {
                let  k2,k3;

                let l =h;
                if (ind3.includes('горизонтальные') || ind3.includes('верх')){
                    l =w;
                }

                if (
                    ind3 === 'Створка от краев к середине' ||
                    ind3 === 'Створки от краев к середине горизонтальные' ||
                    ind3 === 'Створка от середины к краям'
                ) {
                    k2 = 2;
                } else {
                    k2 = 1;
                }
                k3 =(Math.ceil(((l -40)/ 320 +  1)) * k2);
                kolvo = ((w + h + 200) / 1000   * k2 * k3).toFixed(3);

            }
            if (
                name.includes('нитедержатель') ||
                name.includes('нитенаправитель') ||
                name.includes('люверс') ||
                name.includes('саморез для п16')
            ) {
                let k;

                if (
                    ind3 === 'Створка от краев к середине' ||
                    ind3 === 'Створки от краев к середине горизонтальные' ||
                    ind3 === 'Створка от середины к краям'
                ) {
                    k = 2;
                } else {
                    k = 1;
                }

                let l =h;
                if (ind3.includes('горизонтальные') || ind3.includes('верх')){
                    l =w;
                }

                kolvo =  (Math.ceil(((l -40)/ 320 +  1)) * k).toFixed(3);


               /* if (h < 1500) {
                    kolvo = (4 * k).toFixed(3);
                } else {
                    kolvo = (6 * k).toFixed(3);
                }*/
            }
            if (
                name.includes('гвоздь мс плиссе 16мм') ||
                name.includes('заглушка')
            ) {
                kolvo = (4).toFixed(3);
            }
            if (name.includes('пятка')) {
                if (
                    ind3 === 'Створка от краев к середине' ||
                    ind3 === 'Створки от краев к середине горизонтальные' ||
                    ind3 === 'Створка от середины к краям'
                ) {
                    kolvo = (4).toFixed(3);
                } else {
                    kolvo = (2).toFixed(3);
                }
            }
            if (name.includes('угол стандарт')) {
                if (ind1 === 'с порожком' || ind1 === 'с порогом') {
                    kolvo = (2).toFixed(3);
                } else {
                    kolvo = (4).toFixed(3);
                }
            }
            if (name.includes('угол порог система п16')) {
                if (ind1 === 'с порожком' || ind1 === 'с порогом') {
                    kolvo = (2).toFixed(3);
                }
            }
            if (name.includes('работа')) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('уплотнитель') && name.includes(uplot.toLowerCase()))
            {
                if( ind3 === 'Створки от краев к середине горизонтальные')
                {
                    kolvo = ((w) / 1000).toFixed(3);
                }
                else
                {
                    kolvo = ((h) / 1000).toFixed(3);
                }
            }


            if (name.includes('промежуточный ')) {
                if (
                    ind3 === 'Створка от краев к середине'
                ) {
                    kolvo = ((h * 2) / 1000).toFixed(3);
                } else  if (

                    ind3 === 'Створки от краев к середине горизонтальные'
                ) {
                    kolvo = ((w * 2) / 1000).toFixed(3);
                } else if (
                    ind3 === 'Створка от середины к краям'
                ) {
                    kolvo = 0;
                } else {
                    kolvo = ((h) / 1000).toFixed(3);
                }
            }
            if (name.includes('вставка') || name.includes('скотч')) {
                let d;

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        d = w;
                        break;

                    default:
                        d = h;
                        break;
                }

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        kolvo = ((w - 69 + w - 30) / 1000).toFixed(3);
                        break;

                    case 'Створки от краев к середине горизонтальные':
                        kolvo = 0;
                        break;

                    default:
                        switch (ind1) {
                            case 'с порожком': {
                                if (ind3 === 'Створка от середины к краям' ) {
                                    kolvo = ((h - 60 + h - 60) / 1000).toFixed(3);
                                } else {
                                    kolvo = ((h - 60 + h - 20) / 1000).toFixed(3);
                                }
                                break;
                            }
                            case 'без порожка': {
                                if (ind3 === 'Створка от середины к краям') {
                                    kolvo = ((h - 69 + h - 69) / 1000).toFixed(3);
                                } else {
                                    kolvo = ((h - 69 + h - 30) / 1000).toFixed(3);
                                }
                                break;
                            }
                        }

                        if (ind3.includes('от краев к середине')) {
                            if (name.includes('метал')) {
                                kolvo = 0;
                            } else {
                                kolvo = (kolvo * 2).toFixed(3);
                            }
                        }
                        break;
                }
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.maxDay = Math.max((result.maxDay ?? 0), parseInt(item.ind1) || 0);
                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);
        if (montage_item) {
            let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
            montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
            dispatch('mounting', {item: montage_item, price: montage_price});
        }
        dispatch('item', result);
    }, 500);

    change();
</script>

<style>

    .parent {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: auto;
        grid-column-gap: 5px;
        grid-row-gap: 0px;
        grid-template-areas:
                    "info info"
                    "width height"
                    "porojek color"
                    "tip setka"
                    "napr ral"
                    "kolvo tkan"
                    "uplot uplot"
                    "comment comment"
                    "imgCalc imgCalc";
    }

    @media (min-width: 575.98px) {
        .parent {
            grid-template-columns: repeat(3, 1fr);

            grid-template-areas:
                     "imgCalc info info"
                     "imgCalc width height"
                     "imgCalc napr porojek"
                     "imgCalc color tip "
                     ". setka tkan"
                     "ral uplot kolvo  "
                     "comment comment comment  ";
        }
    }

    .comment {
        grid-area: comment;
    }

    .info {
        grid-area: info;
    }

    .porojek {
        grid-area: porojek;
    }

    .color {
        grid-area: color;
    }

    .width {
        grid-area: width;
    }

    .height {
        grid-area: height;
    }

    .napr {
        grid-area: napr;
    }

    .tip {
        grid-area: tip;
    }

    .setka {
        grid-area: setka;
    }

    .imgCalc {
        grid-area: imgCalc;
    }

    .kolvo {
        grid-area: kolvo;
    }

    .tkan {
        grid-area: tkan;
    }


    .ral {
        grid-area: ral;
    }
    .uplot {
        grid-area: uplot;
    }


</style>

<div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
    <div class="parent">


        <div class="info">
            <div class="form-group boxed">
                <div class="alert alert-outline-danger">
                    К расчету принимаются только размеры готового изделия!
                </div>
            </div>
        </div>
        <div class="porojek">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <label class="form-label" for="porojek">Порожек</label>
                    <select id="porojek" class="form-control form-select" bind:value={ind1}
                            disabled={(ind3.includes('Створка сверху вниз') || ind3.includes('Створка снизу вверх'))}
                            on:change={() => {changeInd2(); change()}}>
                        {#each Object.entries(porojek) as [value, name]}
                            <option value="{value}">{name}</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
        <div class="color">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <label for="color" class="form-label">Цвет</label>
                    <select id="color" class="form-control form-select" bind:value={$ind2}
                            on:change={() => {changeInd2(); change()}}>
                        {#each Object.entries(color) as [value, name]}
                            <option value="{value}">{name}</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>

        <div class="width">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <label class="form-label">300 ≥ Шир., мм
                        ≥ { options.max && options.max.width ? options.max.width : 3000 }</label>
                    <input type="number" class="form-control text-center" step="10" min="300"
                           max="{ options.max && options.max.width ? options.max.width : 3000 }"
                           bind:value={$width} use:validate_int={$width}>
                </div>
            </div>
        </div>
        <div class="height">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <label class="form-label">300 ≥ Выс., мм
                        ≥ { options.max && options.max.height ? options.max.height : 2700 }</label>
                    <input type="number" class="form-control text-center" step="10" min="300"
                           max="{ options.max && options.max.height ? options.max.height : 2700 }"
                           bind:value={$height} use:validate_int={$height}>
                </div>
            </div>
        </div>

        <div class="napr">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <label class="form-label">Направление</label>
                    <select class="form-control form-select" bind:value={ind3}
                            on:change={() => {changeInd3();changeInd2(); change()}}>
                        {#each otkrivanie as item}
                            <option value="{item}">{item}</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>

        <div class="tip">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <label class="form-label">Тип</label>
                    <select class="form-control form-select" bind:value={tip}
                            on:change={() => {changeTkan(); change()}}>
                        {#if ind3.includes('краев')}
                            {#each tip_Polotno as item}
                                <option value="{item}">{item}</option>
                            {/each}

                        {:else}
                            {#each tip_Polotno2 as item}
                                <option value="{item}">{item}</option>
                            {/each}

                        {/if}
                    </select>
                </div>
            </div>
        </div>

        <div class="setka">
            {#if tip.includes('СЕТКА')}
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Тип сетки</label>
                        <select class="form-control form-select" bind:value={ind6}>
                            {#each setka as item}
                                <option value="{item}">{item}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            {/if}
        </div>

        <img class="imgCalc img-fluid  p-3"
             src="/img/plisse/ind3/{ind3.toLowerCase().replace('створки', 'створка').replaceAll(' ', '-')}-{$ind2.toLowerCase()}.jpg"/>

        <div class="kolvo">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <label class="form-label">Количество</label>
                    <input type="number" class="form-control text-center" min="1" bind:value={$count}>
                </div>
            </div>
        </div>



            <div class="uplot">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Уплотнитель</label>
                        <select class="form-control form-select" bind:value={uplot}>
                            <option value="Без уплотнения">Без уплотнения</option>
                            <option value="Магнитный">Магнитный</option>
                        </select>
                    </div>
                </div>
            </div>


        <div class="ral">
            <RalColor color={$ind2} bind:comment={$comment}/>
        </div>


        <div class="tkan">
            {#if tip.includes('ТКАНЬ')}
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ткань</label>
                        <select class="form-control form-select" bind:value={tkan} on:change={() => {changeTkan(); change()}} >

                            {#each tkani as item}
                                <option value="{item}">{item}</option>
                            {/each}

                        </select>
                    </div>
                </div>
            {/if}
        </div>

        <div class="comment">
            <div class="form-group boxed">
                <div class="input-wrapper">
                    <div class="input-wrapper">
                        <label class="form-label">Примечание</label>
                        <textarea class="form-control" bind:value={$comment}></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

